import OperatorStatByCompanies from "../components/OperatorStat/OperatorStatByCompanies/OperatorStatByCompanies";
import OperatorStatBySalesPoints from "../components/OperatorStat/OperatorStatBySalesPoints/OperatorStatBySalesPoints";
import OperatorTotalStat from "../components/OperatorStat/OperatorTotalStat/OperatorTotalStat";
import PlayerFolder from "../components/Player/PlayerFolder/PlayerFolder";
import PlayerMedia from "../components/Player/PlayerMedia/PlayerMedia";
import PlayerActiveSalesPoints from "../components/Player/PlayerActiveSalesPoints/PlayerActiveSalesPoints";
import PlayerMediaStats from "../components/Player/PlayerMediaStats/PlayerMediaStats";
import PlayerSalesPointStats from "../components/Player/PlayerSalesPointStats/PlayerSalesPointStats";
import PromoterCategory from "../components/Promoter/PromoterCategory/PromoterCategory";
import PromoterSection from "../components/Promoter/PromoterSection/PromoterSection";
import PromoterVideo from "../components/Promoter/PromoterVideo/PromoterVideo";
import PromoterSalesPointActiveDevices
	from "../components/Promoter/PromoterSalesPointActiveDevices/PromoterSalesPointActiveDevices";
import PromoterVideoStats from "../components/Promoter/PromoterVideoStats/PromoterVideoStats";
import PromoterSalesPointStats from "../components/Promoter/PromoterSalesPointStats/PromoterSalesPointStats";
import PromoterSettings from "../components/Promoter/PromoterSettings/PromoterSettings";
import LoanOrders from "../components/Loan/Order/LoanOrders";
import promoterLogo from "../assets/images/promoter-logo.svg";
import GeoActivity from "../components/Statistics/GeoActivity/GeoActivity";

const OperatorUserRoutes = [
	{
		collapse: false,
		path: "/",
		name: {
			"ru": "Главная",
			"en": "Main",
			"sk": "Hlavná"
		},
		state: "home",
		icon: "mdi mdi-home",
	},
	{
		path: "/dashboard/statistics/companies",
		name: {
			"ru": "По компаням",
			"en": "By companies",
			"sk": "Podľa spoločnosti"
		},
		mini: "B",
		icon: "mdi mdi-city",
		component: OperatorStatByCompanies,
		userAttribute: "AllowAppReports",
	},
	{
		path: "/dashboard/statistics/stores",
		name: {
			"ru": "По торговым точкам",
			"en": "By trader points",
			"sk": "Podľa bodov obchodníka"
		},
		mini: "B",
		icon: "mdi mdi-store",
		component: OperatorStatBySalesPoints,
		userAttribute: "AllowAppReports",
	},
	{
		path: "/dashboard/statistics/geoActivity",
		name: {
			"ru": "Geo активность",
			"en": "Geo activity",
			"sk": "Geo activity"
		},
		mini: "B",
		icon: "mdi mdi-map-marker-radius",
		component: GeoActivity,
		companyAttribute: "AllowGeoActivity",
	},
	{
		path: "/dashboard/statistics/total",
		name: {
			"ru": "Общий отчет",
			"en": "General report",
			"sk": "Všeobecná správa"
		},
		mini: "B",
		icon: "mdi mdi-chart-line",
		component: OperatorTotalStat,
		userAttribute: "AllowAppReports",
	},
	{
		collapse: true,
		path: "/dashboard/player",
		name: {
			"ru": "Плеер",
			"en": "Player",
			"sk": "Player"
		},
		state: "player",
		icon: "mdi mdi-play-circle-outline",
		userAttribute: "AllowPlayer",
		child: [
			{
				path: "/dashboard/player/folders",
				name: {
					"ru": "Папки",
					"en": "Folders",
				},
				mini: "B",
				icon: "mdi mdi-folder-multiple",
				component: PlayerFolder
			},
			{
				path: "/dashboard/player/media",
				name: {
					"ru": "Медиа",
					"en": "Media",
				},
				mini: "B",
				icon: "mdi mdi-file-multiple",
				component: PlayerMedia
			},
			{
				path: "/dashboard/player/stats/activeSalesPoints",
				name: {
					"ru": "Активные торговые точки",
					"en": "Active sales points",
				},
				mini: "B",
				icon: "mdi mdi-store",
				component: PlayerActiveSalesPoints
			},
			{
				path: "/dashboard/player/stats/media",
				name: {
					"ru": "Воспроизведений медиа",
					"en": "Media playback amount",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: PlayerMediaStats
			},
			{
				path: "/dashboard/player/stats/store",
				name: {
					"ru": "Воспроизведений по тт",
					"en": "Playback amount by stores",
				},
				mini: "B",
				icon: "mdi mdi-format-list-bulleted",
				component: PlayerSalesPointStats
			},
		]
	},
	{
		collapse: true,
		path: "/dashboard/promoter",
		name: {
			"ru": "Promoter",
			"en": "Promoter",
			"sk": "Promoter"
		},
		state: "promoter",
		svgIcon: promoterLogo,
		userAttribute: "AllowPromoter",
		child: [
			{
				path: "/dashboard/promoter/videos",
				name: {
					"ru": "Библиотека медиа",
					"en": "Media library",
				},
				mini: "B",
				icon: "mdi mdi-file-video",
				component: PromoterVideo
			},
			{
				collapse: true,
				name: {
					"ru": "Статистика",
					"en": "Statistics",
				},
				state: "promoterStatistics",
				icon: "mdi mdi-settings-box",
				subchild: [
					{
						path: "/dashboard/promoter/stats/video",
						name: {
							"ru": "Отчет о воспроизведении",
							"en": "Playback report",
						},
						mini: "B",
						icon: "mdi mdi-format-list-bulleted",
						component: PromoterVideoStats
					},
					{
						path: "/dashboard/promoter/stats/store",
						name: {
							"ru": "Отчет по магазинам",
							"en": "Store playback report",
						},
						mini: "B",
						icon: "mdi mdi-format-list-bulleted",
						component: PromoterSalesPointStats
					},
					{
						path: "/dashboard/promoter/stats/activeDevices",
						name: {
							"ru": "Активные устройства",
							"en": "Active devices",
						},
						mini: "B",
						icon: "mdi mdi-cellphone-andrAdminid",
						component: PromoterSalesPointActiveDevices
					},
				]
			},
			{
				collapse: true,
				name: {
					"ru": "Настройки",
					"en": "Settings",
					"sk": "Nastavenie"
				},
				state: "promoterSettings",
				icon: "mdi mdi-settings-box",
				subchild: [
					{
						path: "/dashboard/promoter/settings",
						name: {
							"ru": "Основные",
							"en": "Main",
						},
						mini: "B",
						icon: "mdi mdi-settings",
						component: PromoterSettings
					},
					{
						path: "/dashboard/promoter/categories",
						name: {
							"ru": "Категории",
							"en": "Categories",
						},
						mini: "B",
						icon: "mdi mdi-folder-multiple",
						component: PromoterCategory
					},
					{
						path: "/dashboard/promoter/sections",
						name: {
							"ru": "Разделы",
							"en": "Sections",
						},
						mini: "B",
						icon: "mdi mdi-folder-multiple-outline",
						component: PromoterSection
					},]
			},
		]
	},
	{
		collapse: false,
		path: "/dashboard/loan/orders",
		name: {
			"ru": "Кредиты",
			"en": "Loans",
			"sk": "Úver"
		},
		state: "loan-orders",
		icon: "mdi mdi-credit-card",
		component: LoanOrders,
		userAttribute: "AllowLoans",
	},
	{
        collapse: false,
		path: "/chat",
		isLink: true,
        name: {
            "ru": "Поддержка",
            "en": "Support",
            "sk": "Podpora"
        },
        state: "chat",
        icon: "mdi mdi-comment-multiple-outline",
        userAttribute: "AllowSupport",
    },

];
export default OperatorUserRoutes;



// WEBPACK FOOTER //
// ./src/routes/operatorUserRoutes.js